import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";

export const StyledShowMoreButton = styled.button<{ isCollapsed: boolean }>`
    display: flex;
    align-items: baseline;
    gap: 4px;
    padding: 0;
    background: none;
    border: none;

    ${SWReactIcons} {
        transform: ${({ isCollapsed }) => (isCollapsed ? "unset" : "rotate(180deg) translateY(-100%)")};
    }
`;
